module.exports = __webpack_public_path__ + "static/img/2_8_2.d1878d65.jpg";